var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLinkedinTempIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7046_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8984 48.8984C17.8984 29.5685 33.5685 13.8984 52.8984 13.8984C72.2284 13.8984 87.8984 29.5685 87.8984 48.8984C87.8984 68.2284 72.2284 83.8984 52.8984 83.8984C33.5685 83.8984 17.8984 68.2284 17.8984 48.8984Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8984 45.0266V44.2766C37.4842 44.2766 37.1484 44.6124 37.1484 45.0266H37.8984ZM44.2142 45.0266H44.9642C44.9642 44.6124 44.6284 44.2766 44.2142 44.2766V45.0266ZM44.2142 64.8984V65.6484C44.6284 65.6484 44.9642 65.3127 44.9642 64.8984H44.2142ZM37.8984 64.8984H37.1484C37.1484 65.3127 37.4842 65.6484 37.8984 65.6484V64.8984ZM50.53 64.8984H49.78C49.78 65.3127 50.1158 65.6484 50.53 65.6484V64.8984ZM56.0563 64.8984V65.6484C56.4705 65.6484 56.8063 65.3127 56.8063 64.8984H56.0563ZM62.3721 64.8984H61.6221C61.6221 65.3127 61.9579 65.6484 62.3721 65.6484V64.8984ZM67.8984 64.8984V65.6484C68.3127 65.6484 68.6484 65.3127 68.6484 64.8984H67.8984ZM44.2142 37.0779H43.4642C43.4642 38.4245 42.3814 39.5074 41.0563 39.5074V40.2574V41.0074C43.2194 41.0074 44.9642 39.2433 44.9642 37.0779H44.2142ZM41.0563 40.2574V39.5074C39.7313 39.5074 38.6484 38.4245 38.6484 37.0779H37.8984H37.1484C37.1484 39.2433 38.8933 41.0074 41.0563 41.0074V40.2574ZM37.8984 37.0779H38.6484C38.6484 35.7313 39.7313 34.6484 41.0563 34.6484V33.8984V33.1484C38.8933 33.1484 37.1484 34.9126 37.1484 37.0779H37.8984ZM41.0563 33.8984V34.6484C42.3814 34.6484 43.4642 35.7313 43.4642 37.0779H44.2142H44.9642C44.9642 34.9126 43.2194 33.1484 41.0563 33.1484V33.8984ZM37.8984 45.0266V45.7766H44.2142V45.0266V44.2766H37.8984V45.0266ZM44.2142 45.0266H43.4642V64.8984H44.2142H44.9642V45.0266H44.2142ZM44.2142 64.8984V64.1484H37.8984V64.8984V65.6484H44.2142V64.8984ZM37.8984 64.8984H38.6484V45.0266H37.8984H37.1484V64.8984H37.8984ZM50.53 52.5779H49.78V64.8984H50.53H51.28V52.5779H50.53ZM50.53 64.8984V65.6484H56.0563V64.8984V64.1484H50.53V64.8984ZM56.0563 64.8984H56.8063V53.7702H56.0563H55.3063V64.8984H56.0563ZM56.0563 53.7702H56.8063C56.8063 52.9202 57.0597 52.2066 57.4693 51.7191C57.8682 51.2445 58.4467 50.9433 59.2142 50.9433V50.1933V49.4433C58.0081 49.4433 57.0076 49.937 56.321 50.754C55.6451 51.5583 55.3063 52.6331 55.3063 53.7702H56.0563ZM59.2142 50.1933V50.9433C59.9236 50.9433 60.5102 51.2936 60.942 51.847C61.3832 52.4123 61.6221 53.1445 61.6221 53.7702H62.3721H63.1221C63.1221 52.8062 62.769 51.75 62.1246 50.9242C61.4709 50.0866 60.4785 49.4433 59.2142 49.4433V50.1933ZM62.3721 53.7702H61.6221V64.8984H62.3721H63.1221V53.7702H62.3721ZM62.3721 64.8984V65.6484H67.8984V64.8984V64.1484H62.3721V64.8984ZM67.8984 64.8984H68.6484V52.5779H67.8984H67.1484V64.8984H67.8984ZM67.8984 52.5779H68.6484C68.6484 51.1609 67.8599 49.1014 66.3342 47.4063C64.7812 45.681 62.4158 44.2766 59.2142 44.2766V45.0266V45.7766C61.9337 45.7766 63.9104 46.9556 65.2193 48.4098C66.5554 49.8942 67.1484 51.6103 67.1484 52.5779H67.8984ZM59.2142 45.0266V44.2766C56.0127 44.2766 53.6472 45.681 52.0943 47.4063C50.5685 49.1014 49.78 51.1609 49.78 52.5779H50.53H51.28C51.28 51.6103 51.8731 49.8942 53.2092 48.4098C54.5181 46.9556 56.4947 45.7766 59.2142 45.7766V45.0266Z",
    fill: "#3953FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7046_155",
    x: -0.00156212,
    y: -0.00156212,
    width: 105.8,
    height: 105.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7046_155"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7046_155"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7046_155",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedinTempIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/linkedinTempIcon.8bf2d0fc.svg";
export { ForwardRef as ReactComponent };